export function HolidayCtrl ($uibModalInstance, $scope, sessionObjAPI, workshopAPI) {

  $scope.publicBookingsOnly = false;
  $scope.settings           = sessionObjAPI.base();

  /**
   * when using the time from a date after daylight savings and adding
   * it to a date before daylight savings, moment is converting the hour to
   * be an hour later. Because of that, we set the hour, second, minute, millisecond
   * separately to ensure that daylight savings is unaffected.
   * bugfix/WOR-1155
   */
  $scope.create = function () {
    workshopAPI.post('/unavailable_times', {
      unavailable_times: [{
        date                     : $scope.date,
        entire_day               : true,
        public_booking_diary_only: $scope.publicBookingsOnly,
        local_start_time: moment($scope.date)
          .hour(moment($scope.company.shop_opens, 'HH:mm:ss').hour())
          .millisecond(moment($scope.company.shop_opens, 'HH:mm:ss').millisecond())
          .minute(moment($scope.company.shop_opens, 'HH:mm:ss').minute())
          .second(moment($scope.company.shop_opens, 'HH:mm:ss').second())
          .format('YYYY-MM-DDTHH:mm:ssZ'),
        local_end_time: moment($scope.date)
          .hour(moment($scope.company.shop_closes, 'HH:mm:ss').hour())
          .millisecond(moment($scope.company.shop_closes, 'HH:mm:ss').millisecond())
          .minute(moment($scope.company.shop_closes, 'HH:mm:ss').minute())
          .second(moment($scope.company.shop_closes, 'HH:mm:ss').second())
          .format('YYYY-MM-DDTHH:mm:ssZ')
      }]
    })
    .then(() => {
      $uibModalInstance.close();
    })
    .catch(err => {
      $uibModalInstance.dismiss(err);
    });
  };
}